/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { closeModal, switchModal, speak } from '../../actions';
import X from '../../assets/login/x.svg';

const Onboarding4 = (props) => {
  const history = useHistory();
  return (
    <div className="modal onboarding-background onboarding-4">
      <img onClick={props.closeModal} className="x-icon" src={X} alt="x" />
      <h2 className="onboarding-header">
        Check this out!
      </h2>
      <div className="onboarding-main-container">
        <div className="onboarding-body">
          <div>
            <div className="onboarding-circle">4</div>
          </div>
          <div>
            <h4 className={`${props.speechEnabled && 'bolded'} color`} onClick={props.speak}>Finding new surveys</h4>
            <div className="onboarding-text-container">
              <p onClick={props.speak} className={`${props.speechEnabled && 'bolded'} color`}>
                Once you finish your first survey, you will receive recommendations for additional surveys that might be of interest to you. You can always select other surveys from the main menu.
              </p>
            </div>
          </div>
        </div>
        <div className="onboarding-nav">
          <p onClick={() => props.switchModal('Onboarding3')} className="skip">Back</p>
          <p onClick={() => {
            props.closeModal();
            history.push('/dashboard');
          }}
            className="skip"
          >Dashboard
          </p>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => (
  {
    speechEnabled: state.speech.enabled,
  }
);

export default connect(mapStateToProps, { closeModal, switchModal, speak })(Onboarding4);
